/* eslint-disable jsx-a11y/iframe-has-title */
import React from 'react';
import { useHtmlToPrint } from './hooks/useHtmlToPrint';
import HtmlToPrintForm from './components/HtmlToPrintForm';
import HtmlPreview from './components/HtmlPreview';
import PrintActions from './components/PrintActions';
import {
  Container,
  Header,
  Title,
  Description,
  Content,
  LeftColumn,
  RightColumn,
  Section,
  SectionTitle,
} from './styles';

const HtmlToPrintArea = () => {
  const {
    // State
    selectedPrintType,
    itemId,
    selectedMockName,
    htmlContent,
    isLoading,
    isPrinting,
    error,
    // Computed values
    printTypeOptions,
    mockNameOptions,
    currentPrintTypeLabel,
    currentMockLabel,
    canFetchHtml,
    canPrint,
    // Actions
    handlePrintTypeChange,
    handleIdChange,
    handleMockNameChange,
    fetchHtmlContent,
    printHtml,
    resetForm,
    clearHtmlContent,
    // Refs
    iframeRef,
  } = useHtmlToPrint();

  return (
    <Container>
      <iframe ref={iframeRef} style={{ display: 'none' }} />
      <Header>
        <Title>Área de Impressão HTML</Title>
        <Description />
      </Header>
      <Content>
        <LeftColumn>
          <Section>
            <SectionTitle>Configuração</SectionTitle>
            <HtmlToPrintForm
              selectedPrintType={selectedPrintType}
              itemId={itemId}
              selectedMockName={selectedMockName}
              printTypeOptions={printTypeOptions}
              mockNameOptions={mockNameOptions}
              isLoading={isLoading}
              canFetchHtml={canFetchHtml}
              error={error}
              onPrintTypeChange={handlePrintTypeChange}
              onIdChange={handleIdChange}
              onMockNameChange={handleMockNameChange}
              onFetchHtml={fetchHtmlContent}
              onReset={resetForm}
            />
          </Section>
          <Section>
            <SectionTitle>Ações</SectionTitle>
            <PrintActions
              canPrint={canPrint}
              isPrinting={isPrinting}
              htmlContent={htmlContent}
              currentPrintTypeLabel={currentPrintTypeLabel}
              onPrint={printHtml}
              onClear={clearHtmlContent}
            />
          </Section>
        </LeftColumn>
        <RightColumn>
          <Section>
            <SectionTitle>Preview</SectionTitle>
            <HtmlPreview
              htmlContent={htmlContent}
              isLoading={isLoading}
              currentPrintTypeLabel={currentPrintTypeLabel}
            />
          </Section>
        </RightColumn>
      </Content>
    </Container>
  );
};

export default HtmlToPrintArea;
